<template>
  <v-container fluid pt-0 pl-0 pr-0 pb-0 mt-0>
    <v-layout row wrap>
      <v-snackbar :timeout="6000" :top="true" color="#515151" v-model="upgrade">
        {{ 'consumer.upgrade' | t }}
        <v-btn color="white" flat @click="upgrade = false"> {{ 'consumer.close' | t }}</v-btn>
      </v-snackbar>
      <v-flex md2 d-flex>
        <v-layout row wrap>
          <v-flex md12 mt-3 d-flex class="background_play rounded-tabs-sub">
            <v-card-text>
              <v-row align-top class="tw-txt-color-primary">
                <div class="tamany_titol_sitebar">{{ `playground.sitebar.title` | t }}</div>
                <br />
                <p>{{ `playground.sitebar.description` | t }}</p>
                <!-- - ----------------------------------------------------------------------------------------- -->
                <br />
                <!-- - ----------------------------------------------------------------------------------------- -->
                <div class="tamany_titol_sitebar">{{ `playground.sitebar.sub_title_01` | t }}</div>
                <br />
                <ul>
                  <li>
                    <b> {{ `playground.sitebar.li_01_title_01` | t }}</b> {{ `playground.sitebar.li_01_text_01` | t }}
                  </li>
                  <li>
                    <b> {{ `playground.sitebar.li_01_title_02` | t }}</b> {{ `playground.sitebar.li_01_text_02` | t }}
                  </li>
                  <li>
                    <b> {{ `playground.sitebar.li_01_title_03` | t }}</b> {{ `playground.sitebar.li_01_text_03` | t }}
                  </li>
                </ul>
                <!-- - ----------------------------------------------------------------------------------------- -->
                <br />
                <!-- - ----------------------------------------------------------------------------------------- -->
                <div class="tamany_titol_sitebar">{{ `playground.sitebar.sub_title_02` | t }}</div>
                <br />
                <p>{{ `playground.sitebar.sub_description_02` | t }}</p>
                <br />
                <ul>
                  <li>
                    <b> {{ `playground.sitebar.li_subtitle_01_01` | t }}</b> {{ `playground.sitebar.li_01_text_02` | t }}
                    <br />
                    <ul>
                      <li>
                        <b> {{ `playground.sitebar.li_subli_title_01_01` | t }}</b> {{ `playground.sitebar.li_subli_text_01_01` | t }}
                      </li>
                      <li>
                        <b> {{ `playground.sitebar.li_subli_title_01_02` | t }}</b> {{ `playground.sitebar.li_subli_text_01_02` | t }}
                      </li>
                      <li>
                        <b> {{ `playground.sitebar.li_subli_title_01_03` | t }}</b> {{ `playground.sitebar.li_subli_text_01_03` | t }}
                      </li>
                    </ul>
                  </li>
                  <li>
                    <b> {{ `playground.sitebar.li_subtitle_02_01` | t }}</b> {{ `playground.sitebar.li_01_text_02` | t }}
                    <br />
                    <ul>
                      <li>
                        <b> {{ `playground.sitebar.li_subli_title_02_01` | t }}</b> {{ `playground.sitebar.li_subli_text_02_01` | t }}
                      </li>
                      <li>
                        <b> {{ `playground.sitebar.li_subli_title_02_02` | t }}</b> {{ `playground.sitebar.li_subli_text_02_02` | t }}
                      </li>
                      <li>
                        <b> {{ `playground.sitebar.li_subli_title_02_03` | t }}</b> {{ `playground.sitebar.li_subli_text_02_03` | t }}
                      </li>
                    </ul>
                  </li>
                </ul>

                <!-- - ----------------------------------------------------------------------------------------- -->
                <br />
                <!-- - ----------------------------------------------------------------------------------------- -->
                <div class="tamany_titol_sitebar">{{ `playground.sitebar.tips_title` | t }}</div>
                <br />
                <p>
                  {{ `playground.sitebar.tips_description_01` | t }}
                </p>
                <p>
                  {{ `playground.sitebar.tips_description_02` | t }}
                </p>
                <br /><br /><br />
              </v-row>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md10>
        <v-flex md12 class="mt-3">
          <v-flex d-flex md12>
            <v-flex>
              <div class="headline tw-txt-color-primary ml-3 mb-3 subtitol rounded-tabs-sub">{{ 'playground.subtitle' | t }} {{ 'playground.title_youtube' | t }}</div>
            </v-flex>
          </v-flex>

          <v-flex d-flex md12>
            <v-dialog v-model="dialog" class="ml-3">
              <v-card>
                <v-card-title class="headline mb-0 primary">{{ `playground.dialog.${dialogkey}.title` | t }}</v-card-title>
                <v-card-text class="text-xs-left primary">{{ `playground.dialog.${dialogkey}.text` | t }}</v-card-text>
                <v-card-actions>
                  <v-btn color="primary darken-1 white--text" flat="flat" @click.native="dialog = false">{{ `playground.dialog.${dialogkey}.confirm` | t }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>

          <v-flex d-flex md12 class="ml-3">
            <v-card class="elevation-0">
              <v-layout row>
                <v-text-field
                  box
                  :label="$t('playground.search_query')"
                  v-model="q"
                  returnname="input"
                  id="testing"
                  @keyup="endpointCalc"
                  :hint="$t('playground.hint_search')"
                  persistent-hint
                  required
                ></v-text-field>
              </v-layout>

              <v-layout row>
                <v-flex>
                  <v-menu
                    ref="datetsmenu"
                    :close-on-content-click="false"
                    v-model="datepickerts"
                    :nudge-right="40"
                    :return-value.sync="tspicker"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field slot="activator" v-model="tspicker" :label="$t('playground.date_limit')" prepend-icon="event" readonly></v-text-field>
                    <v-date-picker v-model="tspicker" @input="endpointCalc" :max="datemax"></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs-4></v-flex>

                <v-flex>
                  <v-menu
                    ref="datetsimenu"
                    :close-on-content-click="false"
                    v-model="datepickertsi"
                    :nudge-right="40"
                    :return-value.sync="tsipicker"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field slot="activator" v-model="tsipicker" :label="$t('playground.date_limit_range')" prepend-icon="event" readonly></v-text-field>
                    <v-date-picker v-model="tsipicker" @input="endpointCalc" :max="datemax"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-btn dark small left fab :color="getColor['youtube']" v-clipboard:copy="endpoint">
                  <v-icon>content_copy</v-icon>
                </v-btn>
                <v-textarea rows="2" v-model="endpoint" full-width disabled></v-textarea>
              </v-layout>

              <div primary-title class="tw-txt-color-primary mb-2">
                <div>
                  <h3 class="headline mb-0 ml-3">{{ 'playground.results' | t }}</h3>
                </div>
              </div>

              <v-layout row>
                <v-flex xs-12>
                  <v-toolbar dark :color="getColor['youtube']">
                    <v-btn outline @click="getResults" :loading="loading" :disabled="loading" class="ml-3" small flat>{{ 'playground.get_results' | t }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-flex><img class="logo_trawling_web text-xs-left logo" width="150px" :src="logo" /></v-flex>
                    <v-spacer></v-spacer>
                    <v-flex v-if="this.jsonSource.totalResults">
                      <b>{{ this.jsonSource.totalResults | t }} {{ $t('playground.results') }}</b>
                      <span v-if="this.jsonSource.totalResults >= 100">{{ $t('playground.list_50') }}</span>
                    </v-flex>

                    <v-btn outline right small class="mr-1 hidden-sm-and-down" flat>{{ getConsumer('youtube').counter }} {{ 'playground.request_remaining' | t }}</v-btn>
                    <v-btn outline right small class="mr-1" flat @click.native="upsellingmailupdate('youtube')"> <v-icon>file_upload</v-icon> {{ 'consumer.upselling' | t }} </v-btn>
                  </v-toolbar>
                </v-flex>
              </v-layout>
              <!-- simulator -->
              <v-layout row v-if="simulator">
                <v-flex>
                  <v-layout row wrap>
                    <v-flex xs-12>
                      <v-tabs v-model="stab" color="subtitol" dark slider-color="primary ratlla">
                        <v-tab href="#stab-1" class="text_tab tw-txt-color-primary clear_full separa_tab">{{ 'playground.modeweb' | t }}</v-tab>
                        <v-tab href="#stab-2" class="text_tab tw-txt-color-primary clear_full separa_tab">{{ 'playground.modejson' | t }}</v-tab>
                        <v-tab href="#stab-3" class="text_tab tw-txt-color-primary clear_full separa_tab">{{ 'playground.modetable' | t }}</v-tab>

                        <v-tab-item v-if="stab === 'stab-1'" value="stab-1">
                          <v-layout @click="redirect(item.url)" row wrap v-for="item in jsonSource.data" :key="item.id" xs12 md12 style="background: transparent">
                            <v-flex xs12 md12>
                              <v-card style="background: transparent" flat class="title ml-3 mt-2 tw-txt-color-primary">{{ item.title }}</v-card>
                            </v-flex>
                            <v-flex xs12 md12>
                              <v-card class="ml-3 mt-1 tw-txt-color-primary" style="background: transparent" flat>
                                <span>
                                  <b>{{ 'playground.youtube_view.published' | t }}</b>
                                </span>
                                <span class="mr-1">{{ item.published | datetime }}</span>
                                <span class="ml-3">
                                  <b>{{ 'playground.youtube_view.channel' | t }}</b>
                                </span>
                                <span>{{ item.channelTitle }}</span>
                              </v-card>
                            </v-flex>
                            <v-flex xs12 class="mb-3">
                              <v-card class="ml-3 tw-txt-color-primary" style="background: transparent" flat>
                                <span>
                                  <b>{{ 'playground.youtube_view.views' | t }}</b>
                                  {{ item.viewCount }}
                                </span>
                                <span class="ml-3">
                                  <b>{{ 'playground.youtube_view.likes' | t }}</b>
                                  {{ item.likeCont }}
                                </span>
                                <span class="ml-3">
                                  <b>{{ 'playground.youtube_view.dislikes' | t }}</b>
                                  {{ item.dislikeCount }}
                                </span>

                                <span class="ml-3">
                                  <b>{{ 'playground.youtube_view.favourites' | t }}</b>
                                  {{ item.favoriteCount }}
                                </span>
                                <span class="ml-3">
                                  <b>{{ 'playground.youtube_view.comments' | t }}</b>
                                  {{ item.commentCount }}
                                </span>
                              </v-card>
                            </v-flex>
                            <v-flex xs2>
                              <v-card style="background: transparent" flat class="ml-3 mt-1 tw-txt-color-primary">
                                <v-img sm12 md7 flat v-if="item.thumbnails" :src="item.thumbnails.default.url" aspect-ratio="2"></v-img>
                              </v-card>
                            </v-flex>
                            <v-flex xs10>
                              <v-card style="background: transparent" flat class="mb-2 tw-txt-color-primary">
                                <readmore :text="item.description" class="black--text text-xs-justify ml-3 mt-2 mr-2" />
                              </v-card>
                            </v-flex>
                            <v-flex xs12>&nbsp;</v-flex>
                          </v-layout>
                        </v-tab-item>

                        <v-tab-item v-if="stab === 'stab-2'" value="stab-2">
                          <v-flex>
                            <v-card class="ml-3 mt-1 tw-txt-color-primary" style="background: transparent">
                              <Vue-json-pretty :path="'res'" :data="jsonSource" highlightMouseoverNode showLine style="size: 10px" />
                            </v-card>
                          </v-flex>
                        </v-tab-item>

                        <v-tab-item v-if="stab === 'stab-3'" value="stab-3">
                          <v-data-table :headers="headers" :items="jsonSource.data" :loading="loading" :hide-actions="true" class="elevation-1">
                            <template slot="headerCell" slot-scope="props">{{ props.header.text | t }}</template>
                            <template slot="items" slot-scope="props">
                              <tr>
                                <td v-if="props.item.title" class="text-xs-left">{{ props.item.title }}</td>
                                <td v-if="props.item.published" class="text-xs-left">{{ props.item.published }}</td>
                                <td v-if="props.item.url" class="text-xs-left">{{ props.item.url }}</td>
                                <td v-if="props.item.channelTitle" class="text-xs-left">{{ props.item.channelTitle }}</td>
                                <td v-if="props.item.description" class="text-xs-left">{{ props.item.description }}</td>
                                <td v-if="props.item.viewCount" class="text-xs-left">{{ props.item.viewCount | formatnumber }}</td>
                                <td v-if="props.item.likeCount" class="text-xs-left">{{ props.item.likeCount | formatnumber }}</td>
                                <td v-if="props.item.dislikeCount" class="text-xs-left">{{ props.item.dislikeCount | formatnumber }}</td>
                                <td v-if="props.item.favoriteCount" class="text-xs-left">{{ props.item.favoriteCount | formatnumber }}</td>
                                <td v-if="props.item.commentCount" class="text-xs-left">{{ props.item.commentCount | formatnumber }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-tab-item>
                      </v-tabs>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Readmore from '@/components/Readmore'
import VueJsonPretty from 'vue-json-pretty'
import logo from '@/assets/developed-with-youtube-lowercase-light-low.png'

export default {
  components: {
    Readmore,
    VueJsonPretty
  },
  data() {
    return {
      headers: [
        {
          text: 'playground.youtube_view.title',
          value: 'title',
          sortable: true
        },
        {
          text: 'playground.youtube_view.published',
          value: 'published',
          sortable: true
        },
        { text: 'playground.youtube_view.url', value: 'url', sortable: true },
        {
          text: 'playground.youtube_view.channel',
          value: 'channel',
          sortable: true
        },
        {
          text: 'playground.youtube_view.description',
          value: 'description',
          sortable: true
        },
        {
          text: 'playground.youtube_view.views',
          value: 'views',
          sortable: true
        },
        {
          text: 'playground.youtube_view.likes',
          value: 'likes',
          sortable: true
        },
        {
          text: 'playground.youtube_view.dislikes',
          value: 'dislikes',
          sortable: true
        },
        {
          text: 'playground.youtube_view.favourites',
          value: 'favourites',
          sortable: true
        },
        {
          text: 'playground.youtube_view.comments',
          value: 'comments',
          sortable: true
        }
      ],
      stab: 'stab-1',
      datemax: '2023-01-01',
      dialog: false,
      dialogkey: 'alert',
      endpoint: `${window.location.protocol}//youtube.trawlingweb.com/search`,
      q: 'Barcelona',
      tspicker: null,
      tsipicker: null,
      modal: false,
      datepickerts: null,
      datepickertsi: null,
      datedialogts: false,
      datedialogtsi: false,
      ts: null,
      tsi: null,
      simulator: false,
      loading: false,
      active: null,
      format: 'json',
      jsonSource: {},
      items: [
        { text: 'Timestamp', value: 'ts' },
        { text: 'Timestamp Initial', value: 'tsi' },
        { text: 'Format', value: 'format' }
      ],
      logo,
      upgrade: false
    }
  },
  computed: {
    ...mapGetters(['getServer', 'getConsumer', 'getTokenHeader', 'getUserId', 'getColor'])
  },
  created() {
    this.datemax = this.$time().format('YYYY-MM-DD')
    this.endpointCalc()
    this.$http
      .get(`${this.getServer}/users/${this.getUserId}/consumers`, this.getTokenHeader)
      .then(response => {
        if (response.data !== undefined) this.setMyConsumers(response.data)
      })
      .catch(() => {
        this.rmKey()
      })
  },
  methods: {
    ...mapActions(['setMyConsumers', 'rmKey']),
    endpointCalc() {
      const url = `${window.location.protocol}//youtube.trawlingweb.com/search`
      var query = ''
      const data = {}
      data['q'] = encodeURIComponent(this.q)

      if (this.tspicker !== null) {
        this.$refs.datetsmenu.save(this.tspicker)
        this.datetsmenu = false
        data['ts'] = this.$time(this.tspicker, 'YYYY-MM-DD').valueOf()
      }
      if (this.tsipicker !== null) {
        this.$refs.datetsimenu.save(this.tsipicker)
        this.datetsimenu = false
        data['tsi'] = this.$time(this.tsipicker, 'YYYY-MM-DD').valueOf()
      }

      Object.keys(data).forEach((key, idx) => {
        if (idx === 0) query += `/?token=${this.getConsumer('youtube').token}`
        query += `&${key}=${data[key]}`
      })

      this.endpoint = url + query
    },
    redirect(url) {
      window.open(url, '_blank')
    },
    getResults() {
      this.loading = true
      var url = this.endpoint.replace('&format=xml', '')
      this.$http
        .get(url)
        .then(response => {
          this.loading = false
          this.simulator = true
          this.jsonSource = response.data.response
        })
        .catch(error => {
          this.loading = false
          this.simulator = true
          if (error.response.data.response) {
            this.jsonSource = error.response.data.response
          }
        })
    },
    upsellingmailupdate(type) {
      const server = this.getServer
      const lang = this.$i18n.locale
      this.$http.get(`${server}/users/${this.getUserId}/${type}/${lang}/upsellingmailupdate`, this.getTokenHeader).then(() => {
        console.log(`${server}/users/${this.getUserId}/${type}/${lang}/upsellingmailupdate`)
        this.upgrade = true
      })
      this.$http.get(`${server}/users/${this.getUserId}/${type}/${lang}/upsellingmailclient`, this.getTokenHeader).then(() => {
        console.log(`${server}/users/${this.getUserId}/${type}/${lang}/upsellingmailclient`)
      })
    }
  }
}
</script>

<style>
.rounded-tabs {
  border-radius: 6px !important;
}
.rounded-tabs-sub {
  border-radius: 6px !important;
}
.vjs-tree {
  font-family: Monaco, Menlo, Consolas, Bitstream Vera Sans Mono, monospace;
  font-size: 10px;
}
.tamany_titol {
  font-size: 28px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.tamany_titol_sitebar {
  font-size: 18px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.subtitol {
  padding-top: 8px !important;
  padding-left: 20px !important;
  background-color: #f2f2f2 !important;
  padding-bottom: 6px !important;
}
.nopadding {
  padding: 0px !important;
}
.ratlla {
  height: 6px !important;
}
.padding_left {
  padding-left: 20px !important;
}
.background_play {
  background: linear-gradient(to bottom, rgb(241 85 80 / 15%), #ffffff) !important; /* De rojo a blanco */
}
.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
